import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/components/SideBarStyle.css";
import { User, Clock, Home, LogOut, Briefcase, Building2, Wallet, X } from "lucide-react"; // Changed Bolt to Clock/Briefcase for relavancy
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Sidebar = ({ isOpen, onClose }) => {
  const { logout } = useAuth();

  const handleNavClick = () => {
    // Cerrar el sidebar en móvil cuando se hace clic en un enlace
    if (window.innerWidth <= 768 && onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay para móvil */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      
      <div className={`sidebar d-flex flex-column ${isOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header mt-4 text-center position-relative">
          <button 
            className="sidebar-close-btn d-md-none"
            onClick={onClose}
            aria-label="Cerrar menú"
          >
            <X size={20} />
          </button>
          <h4>ItsYourTime</h4>
          <hr />
        </div>

      <nav className="sidebar-nav ms-3 flex-grow-1">
        <ul className="list-unstyled">
          {/* Dashboard */}
          <li className="mb-4">
            <NavLink
              to="/home-admin"
              end
              className={({ isActive }) => `sidebar-nav-item w-75 ${isActive ? "active" : ""}`}
              onClick={handleNavClick}
            >
              <Home /> <span className="ms-2">Inicio</span>
            </NavLink>
          </li>

          {/* Usuarios */}
          <li className="mb-4">
            <NavLink
              to="/home-admin/users"
              className={({ isActive }) => `sidebar-nav-item w-75 ${isActive ? "active" : ""}`}
              onClick={handleNavClick}
            >
              <User /> <span className="ms-2">Usuarios</span>
            </NavLink>
          </li>

          {/* Sucursales */}
          <li className="mb-4">
            <NavLink
              to="/home-admin/branches"
              className={({ isActive }) => `sidebar-nav-item w-75 ${isActive ? "active" : ""}`}
              onClick={handleNavClick}
            >
              <Briefcase /> <span className="ms-2">Sucursales</span>
            </NavLink>
          </li>

          {/* Aprobaciones */}
          <li className="mb-4">
            <NavLink
              to="/home-admin/approvals"
              className={({ isActive }) => `sidebar-nav-item w-75 ${isActive ? "active" : ""}`}
              onClick={handleNavClick}
            >
              <Clock /> <span className="ms-2">Aprobaciones</span>
            </NavLink>
          </li>

          {/* Sucursales y Usuarios */}
          <li className="mb-4">
            <NavLink
              to="/home-admin/sucursales-usuarios"
              className={({ isActive }) => `sidebar-nav-item w-75 ${isActive ? "active" : ""}`}
              onClick={handleNavClick}
            >
              <Building2 /> <span className="ms-2">Sucursales y Usuarios</span>
            </NavLink>
          </li>

          {/* Retiro de horas */}
          <li className="mb-4">
            <NavLink
              to="/home-admin/claim-approvals"
              className={({ isActive }) => `sidebar-nav-item w-75 ${isActive ? "active" : ""}`}
              onClick={handleNavClick}
            >
              <Wallet /> <span className="ms-2">Retiro de Horas</span>
            </NavLink>
          </li>

        </ul>
      </nav>

      <div className="mt-auto mb-4 ms-3">
        <button
          onClick={() => {
            handleNavClick();
            logout();
          }}
          className="sidebar-nav-item btn text-danger mb-5"
          style={{ border: 'none', background: 'transparent' }}
        >
          <LogOut /> <span className="ms-2">Cerrar sesión</span>
        </button>
      </div>

      <div className="sidebar-footer p-3 border-top text-center">
        <small>© 2026 ItYourTime</small>
      </div>
    </div>
    </>
  );
};

export default Sidebar;
